import { HomeDashboardStore } from "./home.component.dashboard-store";
import { HomeDashboardRefreshPort } from "./home-stream-event.coordinator";

/** Exposes refresh commands for each independently loaded dashboard slice. */
export class HomeDashboardRefreshController implements HomeDashboardRefreshPort {
  constructor(private readonly store: HomeDashboardStore) {}
  refreshPulse(): void { this.store.pulseRefresh$.next(); }
  refreshOverview(): void { this.store.overviewRefresh$.next(); }
  refreshNextBestDecision(): void { this.store.nextBestDecisionRefresh$.next(); }
  refreshDecisionList(): void { this.store.decisionListRefresh$.next(); }
  refreshCalendarDecisionState(): void { this.store.calendarDecisionRefresh$.next(); }
  refreshDecisionDetail(): void { this.store.decisionDetailRefresh$.next(); }
  refreshDatesSummary(): void { this.store.datesSummaryRefresh$.next(); }
  refreshActivity(): void {
    this.store.activityRefresh$.next();
    this.store.activityHistoryRefresh$.next();
  }
  refreshMetrics(): void { this.store.metricsRefresh$.next(); }
  refreshKnowledgeAttention(): void { this.store.knowledgeAttentionRefresh$.next(); }
  refreshRecentChanges(): void { this.store.recentChangesRefresh$.next(); }
}
